import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2 } from 'lucide-react';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { api, friendlyError } from '@/lib/api';
import { ROUTES } from '@/lib/constants';
import { AUTH } from '@/constants/testIds';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setMessage(null);
    setError(null);
    try {
      const res = await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setMessage(
        res?.data?.message ||
          'Si el email está registrado, recibirás instrucciones para restablecer tu contraseña.'
      );
    } catch (err) {
      setError(friendlyError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Recuperar acceso"
      subtitle="Te enviaremos un enlace para restablecer tu contraseña."
    >
      <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="email" className="text-sm font-medium">Email</Label>
          <Input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid={AUTH.forgotEmail}
            className="h-11 bg-white"
          />
        </div>

        {message && (
          <Alert
            data-testid={AUTH.forgotMessage}
            className="border-[var(--ns-green)]/40 bg-[var(--ns-green)]/8"
          >
            <AlertDescription className="text-[var(--ns-green-700)]">
              {message}
            </AlertDescription>
          </Alert>
        )}
        {error && (
          <Alert variant="destructive">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        <Button
          type="submit"
          disabled={submitting}
          data-testid={AUTH.forgotSubmit}
          className="h-11 rounded-xl bg-gradient-to-r from-[var(--ns-gold)] to-[var(--ns-gold-600)] text-[#1c1612] font-semibold hover:from-[var(--ns-gold-600)] hover:to-[var(--ns-gold-700)] hover:text-white hover:shadow-[var(--ns-glow-gold)] border-0 shadow-[var(--ns-shadow-gold)] transition-all"
        >
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Enviar enlace'}
        </Button>

        <p className="text-sm text-[var(--ns-text-muted)] text-center">
          <Link
            to={ROUTES.login}
            className="text-[var(--ns-gold-600)] hover:text-[var(--ns-gold-700)] font-semibold hover:underline"
          >
            Volver al inicio de sesión
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
}
